import "./css/style.css"
import { Home as HomeIconLucide } from "lucide-react"; // アイコンを別名でインポート
import Menu from "./components/Menu";
import { BrowserRouter, NavLink, Route, Switch } from "react-router-dom";
import { Home } from "./components/Home";
import { Ship } from "./components/Ship";
import { ScrollTop } from "./components/ScrollTop";
import { Plan } from "./components/Plan";
import { Reserve } from "./components/Reserve";
import { Schedule } from "./components/Schedule";
import { BottomTab } from './components/BottomTab';
import { BlogList } from './components/BlogList';
import { BlogDetail } from './components/BlogDetail';
import { Helmet } from 'react-helmet';

export const App = () => {
    const isMobile = window.innerWidth <= 799;

    const openHome = () => {
        window.location.replace("/");

    };
    return (
        <>
            <BrowserRouter>
                <Helmet>
                    <title>有明海・大牟田市三池港発釣り船 【シーラインⅢ】</title>
                    <meta name="description" content="有明海の釣り船 シーラインです。三池港発 大牟田遊漁船で釣り体験を楽しみましょう。" />
                    <meta name="keywords" content="シーライン大牟田,大牟田遊漁船,大牟田釣り船,三池港遊漁船,有明海 釣り船, 遊漁船,三池港" />
                    <meta property="og:type" content="website" />
                    <meta property="og:locale" content="ja_JP" />
                    <script type="application/ld+json">
                        {`{
                    "@context": "https://schema.org",
                    "@type": "LocalBusiness",
                    "name": "シーラインⅢ",
                    "image": "https://sealine3-new.web.app/images/mainShip.webp",
                    "description": "有明海での釣り船。大牟田市三池港発、初心者も安心の釣り体験を提供します。",
                    "telephone": "+81-70-4287-0007",
                    "email": "sealine3@outlook.jp",
                    "address": {
                      "@type": "PostalAddress",
                      "streetAddress": "福岡県大牟田市新港町４",
                      "postalCode": "836-0061",
                      "addressLocality": "大牟田市",
                      "addressRegion": "福岡県",
                      "addressCountry": "JP"
                    },
                    "url": "https://sealine3-new.web.app/",
                    "priceRange": "¥9000-¥15000",
                    "aggregateRating": {
                      "@type": "AggregateRating",
                      "ratingValue": "4.8",
                      "ratingCount": "150"
                    }
                  }`}
                    </script>
                    <script type="application/ld+json">
                        {`{
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    "name": "シーラインⅢ",
                    "url": "https://sealine3-new.web.app/",
                    "logo": "https://sealine3-new.web.app/images/logo(white).webp",
                    "sameAs": [
                      "https://ameblo.jp/sealine3"
                    ],
                    "telephone": "+81-70-4287-0007",
                    "email": "sealine3@outlook.jp",
                    "address": {
                      "@type": "PostalAddress",
                      "streetAddress": "福岡県大牟田市新港町４",
                      "postalCode": "836-0061",
                      "addressLocality": "大牟田市",
                      "addressRegion": "福岡県"
                    }
                  }`}
                    </script>
                </Helmet>
                <div className="home">
                    <div id="container">
                        <Menu width={200} />
                        <ScrollTop />
                        <h2 className="label">
                            <div className="logo">
                                <a href="/" aria-label="Homeへ戻る"><img alt="シーライン ロゴ" src="images/logo(white).webp" /></a>
                                <p className="label_p">有明海・天草・五島列島へ…いざ！スーパー遊漁船で釣りに行こう!</p><br />
                            </div>
                            <div style={{ position: "fixed", top: "10px", right: "10px", zIndex: 99999, marginTop: "8px", marginRight: "10px" }}>
                                <HomeIconLucide style={{ color: "white" }} onClick={openHome} />
                            </div>
                        </h2>
                        <main>
                            <div className="main-container">
                                <div className="menu">
                                    <h3>Menu</h3>
                                    <nav>
                                        <ul className="menubar">
                                            <li><NavLink activeClassName="active" exact to="/">ホーム</NavLink></li>
                                            <li><NavLink activeClassName="active" to="/Ship">船の紹介</NavLink></li>
                                            <li><NavLink activeClassName="active" to="/Plan">釣り物・料金</NavLink></li>
                                            <li><NavLink activeClassName="active" to="/Reserve">空き状況</NavLink></li>
                                            <li><NavLink activeClassName="active" to="/Schedule">当日の流れ</NavLink></li>
                                        </ul>
                                    </nav>
                                </div>
                                <div className="main">
                                    <Switch>
                                        <Route exact path="/"><Home /></Route>
                                        <Route path="/Ship"><Ship /></Route>
                                        <Route path="/Plan"><Plan /></Route>
                                        <Route path="/Reserve"><Reserve /></Route>
                                        <Route path="/Schedule"><Schedule /></Route>
                                        <Route path="/BlogList"><BlogList /></Route>
                                        <Route path="/BlogDetail/:id" component={BlogDetail} /> {/* 投稿詳細 */}
                                    </Switch>
                                </div>
                            </div>
                        </main>

                        <footer className="footer">
                            <div className="footer-content">
                                <div className="footer-section">
                                    <h3>contact</h3>
                                    <p>船長: 平川 裕一郎</p>
                                    <p>TEL: 070-4287-0007</p>
                                    <p>Email: sealine3@outlook.jp</p>
                                    <NavLink activeClassName="active" exact to="/">ホーム</NavLink>
                                    <NavLink activeClassName="active" exact to="/Ship">船の紹介</NavLink>
                                    <NavLink activeClassName="active" exact to="/Plan">釣り物・料金</NavLink>
                                    <NavLink activeClassName="active" exact to="/Reserve">空き状況</NavLink>
                                    <NavLink activeClassName="active" exact to="/Schedule">当日の流れ</NavLink>
                                </div>
                            </div>
                        </footer>

                        {isMobile && (
                            <BottomTab />
                        )}
                    </div>
                    {isMobile && (
                        <BottomTab />
                    )}

                </div>
            </BrowserRouter>
        </>
    );
}
